/**
 * Takes variant, returns function that updates replaces window state
 * @param {any} variant
 */
const updateVariantUrl = (variant) => {

  const url = new URL(window.location.href)

  if (variant && url.searchParams.has('variant')) {
    url.searchParams.set('variant', variant.id)
  } else if (variant && !url.searchParams.has('variant')) {
    url.searchParams.append('variant', variant.id)
  } else {
    url.searchParams.delete('variant')
  }

  window.history.replaceState({ ...window.history.state }, '', url.toString())
}

export default updateVariantUrl;